import React from 'react';
import { createComponent, PropTypes } from "../../../../wayin-react";
import AssetUploader from "../../../core/asset-uploader";
import Panel from "../../panel";
import SharingInput from "./sharing-fields/input";
import SharingLink from "./sharing-fields/link";
import SharingTextArea from "./sharing-fields/textarea";
import { positions, documentTypes } from "../../../../enums";
/**
 *
 * this component will selectively render the relevant field for sharing based on the passed in 'type' prop
 */

var SharingField = createComponent({
  displayName: 'SharingField',
  defaultProps: {
    formName: '',
    assetUploaderConfig: {
      prefix: '',
      libraryRef: '',
      containerRef: ''
    }
  },
  propTypes: {
    formName: PropTypes.string,
    assetUploaderConfig: PropTypes.shape({
      prefix: PropTypes.string,
      libraryRef: PropTypes.string,
      containerRef: PropTypes.string
    })
  },
  state: {
    hasError: {
      value: false,
      updater: function updater(_updater, p) {
        return {
          setHasError: function setHasError(p) {
            return _updater(p);
          }
        };
      }
    }
  },
  handlers: {
    onFieldChanged: function onFieldChanged(p) {
      return function (e, _ref) {
        var _p$onChange;

        var value = _ref.value;
        p.setHasError(p.hasError);
        p.onChange(e, (_p$onChange = {}, _p$onChange[p.name] = value, _p$onChange), p);
      };
    }
  },
  lifecycles: {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return this.props.value !== nextProps.value;
    }
  },
  render: function render(p) {
    return p.type === 'input' ? /*#__PURE__*/React.createElement(SharingInput, {
      name: p.name,
      value: p.value,
      onChange: p.onFieldChanged,
      maxChars: {
        content: p.maxChars,
        position: positions.RIGHT
      },
      placeholder: p.placeholder,
      required: p.required,
      hasError: p.hasError
    }) : p.type === 'textarea' ? /*#__PURE__*/React.createElement(SharingTextArea, {
      name: p.name,
      value: p.value,
      onChange: p.onFieldChanged,
      maxChars: {
        content: p.maxChars,
        position: positions.RIGHT
      },
      placeholder: p.placeholder,
      required: p.required,
      hasError: p.hasError
    }) : p.type === 'asset' ? /*#__PURE__*/React.createElement(AssetUploader.Image, {
      name: p.name,
      value: p.value,
      onChange: p.onFieldChanged,
      libraryRef: p.assetUploaderConfig.libraryRef,
      containerRef: p.assetUploaderConfig.containerRef,
      stateIdentifier: p.assetUploaderConfig.prefix + "-" + p.formName + "-" + p.network + "-sharing-uploader",
      fileType: documentTypes.IMAGE,
      isTransparent: true,
      isFluid: true
    }) : p.type === 'select' ? /*#__PURE__*/React.createElement(SharingLink, {
      name: p.name,
      value: p.value,
      onChange: p.onFieldChanged,
      options: [{
        text: 'Context aware experience link',
        value: 'ctx:smarturl'
      }, {
        text: 'Custom URL',
        value: 'url'
      }],
      search: false,
      isFluid: true
    }) : p.type === 'label' ? /*#__PURE__*/React.createElement(SharingLabel, {
      text: p.value
    }) : null;
  }
});

var SharingLabel = function SharingLabel(p) {
  return /*#__PURE__*/React.createElement(Panel, {
    padding: {
      vertical: null,
      horizontal: null
    },
    hasBorder: false,
    byline: p.text
  });
};

export default SharingField;
//# sourceMappingURL=sharing-field.js.map